import { doc, setDoc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

export interface MaintenanceSettings {
  enabled: boolean;
  message: string;
  estimatedTime: string;
  contact: string;
  title: string;
  subtitle: string;
  backgroundColor: string;
  cardColor: string;
  textColor: string;
  accentColor: string;
  logoUrl: string;
  animationEnabled: boolean;
  customCss: string;
  updatedAt: Date;
}

export const maintenanceService = {
  async enableMaintenance(settings: Partial<MaintenanceSettings>): Promise<void> {
    try {
      const maintenanceRef = doc(db, 'system', 'maintenance');
      await setDoc(maintenanceRef, {
        enabled: true,
        message: settings.message || 'Sistema em manutenção programada',
        estimatedTime: settings.estimatedTime || '2-4 horas',
        contact: settings.contact || 'contato@playkidseventos.com.br',
        title: settings.title || 'Sistema em Manutenção',
        subtitle: settings.subtitle || 'Estamos trabalhando para melhorar sua experiência',
        backgroundColor: settings.backgroundColor || 'linear-gradient(135deg, #1e293b 0%, #334155 50%, #1e293b 100%)',
        cardColor: settings.cardColor || 'rgba(255, 255, 255, 0.1)',
        textColor: settings.textColor || '#ffffff',
        accentColor: settings.accentColor || '#f59e0b',
        logoUrl: settings.logoUrl || '/images/LOGO.png',
        animationEnabled: settings.animationEnabled !== false,
        customCss: settings.customCss || '',
        updatedAt: new Date()
      });
      console.log('✅ Modo manutenção ativado');
    } catch (error) {
      console.error('❌ Erro ao ativar modo manutenção:', error);
      throw error;
    }
  },

  async disableMaintenance(): Promise<void> {
    try {
      const maintenanceRef = doc(db, 'system', 'maintenance');
      await setDoc(maintenanceRef, {
        enabled: false,
        updatedAt: new Date()
      });
      console.log('✅ Modo manutenção desativado');
    } catch (error) {
      console.error('❌ Erro ao desativar modo manutenção:', error);
      throw error;
    }
  },

  async getMaintenanceSettings(): Promise<MaintenanceSettings | null> {
    try {
      const maintenanceRef = doc(db, 'system', 'maintenance');
      const docSnap = await getDoc(maintenanceRef);
      
      if (docSnap.exists()) {
        const data = docSnap.data();
        return {
          enabled: data.enabled || false,
          message: data.message || 'Sistema em manutenção programada',
          estimatedTime: data.estimatedTime || '2-4 horas',
          contact: data.contact || 'contato@playkidseventos.com.br',
          title: data.title || 'Sistema em Manutenção',
          subtitle: data.subtitle || 'Estamos trabalhando para melhorar sua experiência',
          backgroundColor: data.backgroundColor || 'linear-gradient(135deg, #1e293b 0%, #334155 50%, #1e293b 100%)',
          cardColor: data.cardColor || 'rgba(255, 255, 255, 0.1)',
          textColor: data.textColor || '#ffffff',
          accentColor: data.accentColor || '#f59e0b',
          logoUrl: data.logoUrl || '/images/LOGO.png',
          animationEnabled: data.animationEnabled !== false,
          customCss: data.customCss || '',
          updatedAt: data.updatedAt?.toDate() || new Date()
        };
      }
      return null;
    } catch (error) {
      console.error('❌ Erro ao obter configurações de manutenção:', error);
      throw error;
    }
  },

  async updateMaintenanceSettings(settings: Partial<MaintenanceSettings>): Promise<void> {
    try {
      const maintenanceRef = doc(db, 'system', 'maintenance');
      await setDoc(maintenanceRef, {
        ...settings,
        updatedAt: new Date()
      }, { merge: true });
      console.log('✅ Configurações de manutenção atualizadas');
    } catch (error) {
      console.error('❌ Erro ao atualizar configurações de manutenção:', error);
      throw error;
    }
  }
};
